<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Tnaflix Downloader?</h3>
            <p>
                Tnaflix Downloader is a free Chrome extension that allows you to download videos from Tnaflix for offline viewing. Save videos in their original quality to watch anytime, anywhere.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Tnaflix Downloader work?</h3>
            <p>
                Tnaflix Downloader uses a browser extension to detect video files on Tnaflix pages. Simply copy the video URL, paste it into our downloader interface, and the extension will extract the video file for download.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is Tnaflix Downloader free?</h3>
            <p>
                Yes, Tnaflix Downloader is completely free to use. There are no hidden fees, subscription plans, or usage limits. Install the extension and start downloading immediately.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">What browsers support Tnaflix Downloader?</h3>
            <p>
                Tnaflix Downloader works with Chrome, Edge, Brave, and other Chromium-based browsers. The extension is lightweight and doesn't slow down your browsing experience.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
